import * as React from 'react';
import { SingleValueComponent } from '../common';
import { Expandable, ShouldTruncate } from 'ui/expandable';
import styles from './expandable-text.scss';

import { CSSProperties } from 'react';

export interface ExpandableTextProps extends SingleValueComponent<string> {
  textDisplayMore?: string;
  textDisplayLess?: string;
  visibleTextLength?: number;
  displayBottomLine?: boolean;
  expandAll?:boolean;
}

export class ExpandableText extends React.Component<ExpandableTextProps> {
  public static defaultProps: Partial<ExpandableTextProps> = {
    visibleTextLength: 250,
    displayBottomLine: true
  };

  private contentRender = (collapsed: boolean) => {
    const value = this.props.value || '';
    const visibleText = collapsed ? value.substring(0, this.props.visibleTextLength) : value;

    return visibleText + (collapsed ? '...' : '');
  }

  public render() {
    const {textDisplayMore, textDisplayLess, displayBottomLine, componentId, className, visibleTextLength, expandAll} = this.props;

    const value = this.props.value || '';

    const defaultStyle: CSSProperties = {borderBottomWidth: '1px', borderBottomStyle: 'solid'};
    const currentStyle = displayBottomLine === false ? {paddingBottom: '0'} : defaultStyle;
    const shouldTruncate = ShouldTruncate(value, visibleTextLength) && !expandAll;

    return value ? ( 
    <div>
       {shouldTruncate ?
        <p className={`${styles.expandableTextPrintOnly}`}>
          {value}
        </p>
        :
        null
      }
      <p id={componentId} style={currentStyle}
      className={`${className} ${styles.expandableText}`}>
        {shouldTruncate ?
          <Expandable content={this.contentRender} textDisplayMore={textDisplayMore} textDisplayLess={textDisplayLess} />
          :
          value
        }
      </p>
    </div>
    ) : null;
  }
}
